import { render, staticRenderFns } from "./Placowki.vue?vue&type=template&id=18731b07&scoped=true&"
import script from "./Placowki.vue?vue&type=script&lang=js&"
export * from "./Placowki.vue?vue&type=script&lang=js&"
import style0 from "./Placowki.vue?vue&type=style&index=0&id=18731b07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18731b07",
  null
  
)

export default component.exports